module.exports = __webpack_public_path__ + "NcqjkPJTQZlJIFxZdZcTe5Bw1xU1rKptJj_0jans920.0140bbd769fd408b2454.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/NcqjkPJTQZlJIFxZdZcTe5Bw1xU1rKptJj_0jans920.woff2
// module id = ../../../../../src/assets/fonts/font-google/NcqjkPJTQZlJIFxZdZcTe5Bw1xU1rKptJj_0jans920.woff2
// module chunks = 40